enum OrderArticleRowSource {
    ADJUSTMENT = 'Adjustment',
    PURCHASE = 'Purchase',
}

export default OrderArticleRowSource;
